import styled, { css } from "styled-components";
import { cssIf, cssMixin } from "../../utils/styledMixins";
import { padding } from "../../utils/helpers/mixins";

// NOTE: currently css and cssMixins cannot be embedded within cssIf
export const focusWellBorder = css`
  border-radius: ${props => props.theme.borderRadii.big};
  border-width: 1px;
  border-style: solid;
  border-color: ${props => props.theme.projectSpecific.portalWell[`${props.variant || "default"}`].border};
`;

export const focusWell = cssMixin`
  box-sizing: border-box;
  font-size: 14px;
  ${focusWellBorder}
  
  ${cssIf(({thinBorder}) => thinBorder)`
    border-radius: 12.5px;
  `}
  
  ${cssIf(({ hollow }) => !hollow)`
    background-color: ${props => props.theme.projectSpecific.portalWell[`${props.variant || "default"}`].background};
  `}
  
  ${cssIf(({noWellMobile}) => noWellMobile)`
    border: none;
    border-radius: 0;
  `}
  
  /* note I couldnt place this inside the cssIf above as currently cssIf breaks css and cssMixin */
  @media only screen and (min-width: ${props => props.theme.breakpoints.M}) {
    ${cssIf(({noWellMobile}) => noWellMobile)`
      ${focusWellBorder}
      
      ${cssIf(({thinBorder}) => thinBorder)`
        border-radius: 12.5px;
      `}
    `}
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.M}) {
    border-radius: ${props => props.theme.borderRadii.focusWell};
    font-size: 15px;
    
    ${cssIf(({thinBorder}) => thinBorder)`
      border-radius: ${props => props.theme.borderRadii.medium};
    `}
  }
`;

export const FocusWell = styled.div.attrs({
  className: "focus-well",
})`
  ${focusWell()}
`;

export const PaddedFocusWell = styled.div.attrs({
  className: "focus-well focus-well-padded",
})`
  ${focusWell()}
  position: relative;
  padding: 12px 18px 12px;

  @media only screen and (min-width: ${props => props.theme.breakpoints.M}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 58px;

    .well-title {
      display: block;
      text-align: center;
    }
  }

  ${cssIf(({noWellMobile}) => noWellMobile)`
    ${padding()}
    
    @media only screen and (min-width: ${props => props.theme.breakpoints.M}) {
      padding: 24px 58px;
    }
  `}
`;

export const PaddedFocusWellTryLater = styled.div.attrs({
  className: "focus-well-try-later focus-well-padded-try-later",
})`
  ${focusWell()}
  position: relative;
  padding: 12px 18px 12px;
  color: ${props => props.theme.palette.main.white};
  text-align: center;

  @media only screen and (min-width: ${props => props.theme.breakpoints.M}) {
    padding: 24px 58px;
  }

  ${cssIf(({noWellMobile}) => noWellMobile)`
    ${padding()}
    
    @media only screen and (min-width: ${props => props.theme.breakpoints.M}) {
      padding: 24px 58px;
    }
  `}
`;